import { useState } from 'react';
import { ReportParameters } from '../types/appModels';
import { DataStatus } from '../types/appTypes';
import { useData } from './useData';

export type UseReportParamsArgs = {
  encryptedParams?: string;
};

export function useReportParams({ encryptedParams }: UseReportParamsArgs): {
  status: DataStatus;
  decryptedParams?: string;
} {
  const [parseError, setParseError] = useState<boolean>(false);
  const { dataState } = useData<ReportParameters>({
    endpoint: `${process.env.REACT_APP_API_DECRYPT}?ev=${encodeURIComponent(
      encryptedParams ?? ''
    )}`,
    loadWhen: encryptedParams !== undefined && encryptedParams !== '',
  });

  let decryptedParams: string | undefined;
  if (
    dataState.status === DataStatus.Ready &&
    dataState.data !== undefined &&
    !parseError
  ) {
    try {
      const reportParams: ReportParameters = dataState.data;
      const paramsArray = [];

      if (reportParams.crew !== undefined && reportParams.crew !== '')
        paramsArray.push(`CrewName="${reportParams.crew}";`);

      if (reportParams.basin !== undefined && reportParams.basin !== '')
        paramsArray.push(`basincache="${reportParams.basin}";`);

      if (reportParams.onDemandWell !== undefined && reportParams.onDemandWell !== '')
        paramsArray.push(`onDemandWell="${reportParams.onDemandWell}";`);

      if (reportParams.onDemandStage !== undefined && reportParams.onDemandStage !== '')
        paramsArray.push(`onDemandStage={"${reportParams.onDemandStage}"};`);

      if (reportParams.pageIndicator !== undefined && reportParams.pageIndicator !== '') {
        paramsArray.push(`pageIndicator=${reportParams.pageIndicator};`);
      }

      if (
        reportParams.padNumber !== undefined &&
        reportParams.padNumber !== ''
      ) {
        paramsArray.push(`padnumber=${reportParams.padNumber};`);
        paramsArray.push(
          `SetFilter(tableName="${reportParams.tableName ?? 'Engineer Data'}",columnName="PadNumber",values=${reportParams.padNumber});`
        );
      }

      if (paramsArray.length > 0) {
        paramsArray.push(`SetPage(pageTitle="Frac Display");`);
        decryptedParams = paramsArray.join('');
      }

      console.log("decryptedParams",decryptedParams);

    } catch {
      setParseError(true);
    }
  }

  return {
    status: parseError ? DataStatus.Fail : dataState.status,
    decryptedParams,
  };
}